import React from 'react';
import { useIntl } from 'react-intl';
import {
  Field,
  FieldProps,
  useField,
} from 'formik';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';

import ErrorMessage from 'hellospa/components/error-message';
import * as types from 'hellospa/page/prep-and-send/data/types';
import ContactInput from 'hellospa/components/contact-input';
import styles from './index.scss';
import messages from './intl';

type Props = {
  index: number,
};

const Fax = ({ index }: Props) => {
  const intl = useIntl();
  const showInlinePreview = useSelector(selectors.showInlinePreview);

  const parent = `recipients.${index}`;

  const [, meta] = useField<String>(`${parent}.fax`);

  return (
    <div
      className={styles.fields}
      data-qa-ref={`${parent}.fields`}
    >
      <div
        className={classNames(styles.fieldRow, {
          [styles.fullWidthFieldRow]: showInlinePreview,
        })}
      >
        <div
          className={classNames({
            [styles.errorFieldContainer]: meta.touched && meta.error,
          })}
        >
          <label htmlFor={`${parent}.fax`}>
            {intl.formatMessage(messages.fieldFaxLabel)}
          </label>
          <Field name={`${parent}.fax`}>
            {({ field, form }: FieldProps) => (
              <ContactInput
                id={`${parent}.fax`}
                autoFocus={index === 0}
                data-qa-ref={`${parent}.fields.fax`}
                placeholder={intl.formatMessage(messages.fieldFaxPlaceholder)}
                className={styles.dropdownField}
                onSelectContact={(contact: types.Contact) => {
                  form.setFieldValue(field.name, contact.value);
                  form.validateField(field.name);
                }}
                contactTypes={['E', 'F']}
                {...field}
                onChange={(value: string) => form.setFieldValue(field.name, value)} />
            )}
          </Field>
          <div
            className={styles.errorContainer}
            role="fax-error"
            data-qa-ref={`${parent}.errors.fax`}
          >
            <ErrorMessage
              name={`${parent}.fax`}
              className={styles.error} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Fax;
